import { useEffect, useState } from "react";
import { getAuth } from "firebase/auth";
import { useAppData } from "../context/AppContext";
import { Link } from "react-router-dom";

interface Props {}

const ProfilePage = ({}: Props) => {

  const auth = getAuth();
  const { data } = useAppData();

  const user = auth.currentUser;
  const email = user?.email;

  return (
    <div className="min-h-screen bg-gray-100 text-gray-900 px-6 py-20 sm:px-12">
      <div className="max-w-xl mx-auto bg-white rounded-xl shadow-md p-8 text-center">
        <h1 className="text-2xl font-bold mb-4">Tutto's Profile</h1>
        <div className="text-left">
          {data?.user?.username && (
            <div className="flex items-center justify-between mt-1">
              <p className="text-lg text-gray-700">
                {`@${data?.user?.username}`}
              </p>
              <Link
                className="inline-flex justify-center rounded-lg border py-[calc(--spacing(2)-1px)] px-[calc(--spacing(3)-1px)] text-sm transition-colors border-gray-300 text-gray-700 hover:border-gray-400 active:bg-gray-100 active:text-gray-700/80"
                to={"/set-username"}
              >
                Change
              </Link>
            </div>
          )}
          <p className="text-lg text-gray-700 mt-1">{email}</p>
          <p className="text-lg text-gray-700 mt-1">{data?.user?.location ?? "Bananaland"}</p>
        </div>
      </div>

      <div className="max-w-xl mx-auto mt-6 text-center text-gray-700">
        <p>
          Visit the{" "}
          <Link to="/your-bananas" className="text-blue-600 hover:underline">
            Your Bananas
          </Link>{" "}
          to review all of the Tuttobanana's you've sent and received and where across the Bananaverse they've traveled!
        </p>
      </div>
    </div>
  );
};

export default ProfilePage;
